import { render, staticRenderFns } from "./VideoItem.vue?vue&type=template&id=6600de4d&scoped=true&"
import script from "./VideoItem.vue?vue&type=script&lang=js&"
export * from "./VideoItem.vue?vue&type=script&lang=js&"
import style0 from "./VideoItem.vue?vue&type=style&index=0&id=6600de4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6600de4d",
  null
  
)

export default component.exports